import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorOtcFeeRate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
    />
    <path
      fill="#F7A600"
      d="M11.2 9.3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16.2 14.3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.73 9.33a.75.75 0 1 0-1.06-1.06l-6.364 6.364a.75.75 0 1 0 1.06 1.06L15.73 9.33Z"
    />
  </svg>
);
export default SvgTwoColorOtcFeeRate;
